import { useContext } from "react";
import { sharedLib } from "@shared/services/shared.service";
import { useDispatch, useSelector } from "react-redux";
import { WorkspaceType } from "@shared/types";
import { WORKSPACE_STORAGE_KEY } from "@shared/common/constants";
import {
  selectWorkspace,
  selectWorkspaceInitialized,
} from "@shared/slices/common.slice";
import { SocketContext } from "@shared/features/socket/Socket.context";

interface useSharedWorkspaceProps {
  allowAdminWorkspace?: boolean;
}

const useSharedWorkspace = ({
  allowAdminWorkspace,
}: useSharedWorkspaceProps) => {
  const dispatch = useDispatch();
  const { socketHandler } = useContext(SocketContext)!;
  const workspace = useSelector(selectWorkspace);
  const workspaceInitialized = useSelector(selectWorkspaceInitialized);
  const realUser = useSelector(
    sharedLib.selectors.authentication.selectRealUser
  );

  const setWorkspaceType = (updatedWorkspace: WorkspaceType) => {
    const shouldCleanStore =
      !!workspace &&
      updatedWorkspace !== workspace &&
      (workspace === WorkspaceType.DEMO ||
        updatedWorkspace === WorkspaceType.DEMO);

    sharedLib.storageService.setValue(WORKSPACE_STORAGE_KEY, updatedWorkspace);
    dispatch(sharedLib.slices.common.actions.setWorkspace(updatedWorkspace));
    if (shouldCleanStore && workspaceInitialized) {
      dispatch(sharedLib.baseApi.util.resetApiState());
      socketHandler.clear(true);
    }
  };

  const isWorkspaceValid = (workspace?: WorkspaceType) => {
    return (
      !!workspace &&
      (workspace !== WorkspaceType.ADMIN ||
        (allowAdminWorkspace &&
          (realUser?.is_admin || realUser?.is_whop_creator)))
    );
  };

  return {
    setWorkspaceType,
    workspace,
    realUser,
    isWorkspaceValid,
  };
};

export default useSharedWorkspace;
